import { useAsyncExecutor } from "async-executor-hook";
import { FC, useState } from "react";
import { map } from "rxjs";

import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import { getAttributeList } from "../../common/searchParams.utils";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import UsersManagementAdminSearch from "./UsersManagementAdminSearch";
import UsersManagementAdminSidebar from "./UsersManagementAdminSidebar";
import UsersManagementAdminTableNew from "./UsersManagementAdminTableNew";

interface IUsersManagementAdminResource {
  userProfileMe: {};
  userInfo: {};
}
const UsersManagementAdminResource: FC<IUsersManagementAdminResource> = (
  props
) => {
  const { userProfileMe, userInfo } = props;
  const params$ = useQueryParams$().pipe(
    map((params: any) => {
      return {
        ...params,
        user_info: params.user_info || "",
        company_info: params.company_info || "",
        profiles: getAttributeList(params.profiles),
        roles: getAttributeList(params.roles),
      };
    })
  );

  const loadUsers = useAsyncExecutor(
    async (params) => {
      return await networkBackendRequest(`/users/`, HTTP_METHODS.GET, {
        ...params,
      }).then((response) => response.json());
    },
    {
      source$: params$.pipe(
        map((params) => ({
          ...params,
          order: "descending",
          page: params.page ? params.page : 1,
          page_size: ITEMS_PER_PAGE,
        }))
      ),
    }
  );

  const [dataUserEditAdmin, setDataUserEditAdmin] = useState(false);
  const [showModalEdit, updateModalEdit] = useState(false);
  const showEdit = () => {
    updateModalEdit(!showModalEdit);
  };
  const [showModalSuccessRegister, setShowModalSuccessRegister] =
    useState(false);
  const [messageSuccessRegister, setMessageSuccessRegister] = useState("");
  const [titleMessageUsers, setTitleMessageUsers] = useState("");
  return (
    <div>
      <UsersManagementAdminSearch
        params$={params$}
        loadUsers={loadUsers}
        showEdit={showEdit}
      />
      <UsersManagementAdminTableNew
        userInfo={userInfo}
        loadUsers={loadUsers}
        setDataUserEditAdmin={setDataUserEditAdmin}
        showEdit={showEdit}
      />

      {showModalEdit && (
        <UsersManagementAdminSidebar
          dataUserEditAdmin={dataUserEditAdmin}
          toggleModal={() => {
            updateModalEdit(false);
            setDataUserEditAdmin(false);
          }}
          userProfileMe={userProfileMe}
          setShowModalSuccessRegister={setShowModalSuccessRegister}
          setMessageSuccessRegister={setMessageSuccessRegister}
          setTitleMessageUsers={setTitleMessageUsers}
        />
      )}
      {showModalSuccessRegister && (
        <ConfirmationModal
          message={messageSuccessRegister}
          onAccept={() => {
            setMessageSuccessRegister("");
            setTitleMessageUsers("");
            setShowModalSuccessRegister(false);
            const params = { ...loadUsers.getExecution().params, page: 1 };
            loadUsers.execute(params);
          }}
          title={titleMessageUsers}
          toggleModal={() => {
            setMessageSuccessRegister("");
            setTitleMessageUsers("");
            setShowModalSuccessRegister(false);
            const params = { ...loadUsers.getExecution().params, page: 1 };
            loadUsers.execute(params);
          }}
        />
      )}
    </div>
  );
};

export default UsersManagementAdminResource;
